<script>
  // import Logo from "@helpers/Logo.svelte";
  import { budgetBlocks } from "@stores/userData.js";
</script>

<div>
  <!-- <Logo /> -->
  <span class="title">#HouBudget</span>
  <ul>
    <li>
      <a href="#introduction">01. Learn</a>
    </li>
    <li class:locked={false}>
      <a href="#build">02. Build</a>
    </li>
    <li class:locked={$budgetBlocks.length == 0}>
      <a href="#outcomes">03. Outcomes</a>
    </li>
    <li class:locked={$budgetBlocks.length == 0}>
      <a href="#share">04. Share</a>
    </li>
  </ul>
</div>

<style>
  div {
    height: var(--nav-height, 60px);
    display: flex;
    place-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(var(--accent-color-rgb), 0.2);
    position: fixed;
    top: 0;
    width: 100%;
    background: var(--primary-color-base);
    z-index: 9999;
  }

  ul {
    width: 100%;
    max-width: 868px;
    margin-left: auto;
    display: flex;
    /* justify-content: space-between; */
    margin-right: 1rem;
    justify-content: flex-end;
  }

  li {
    font-family: var(--font-serif);
    font-size: 1rem;
    border-left: 1px solid rgba(var(--accent-color-rgb), 0.2);
    padding-left: 1rem;
    margin-left: 1rem;
    text-transform: uppercase;
    transition: filter 300ms ease;
    filter: none;
  }

  li.locked {
    opacity: 0.85;
    filter: blur(2px);
    cursor: not-allowed;
  }

  li.locked a {
    pointer-events: none;
  }

  .title {
    font-size: 1rem;
    padding-left: 1rem;
    font-family: var(--font-serif);
    font-weight: 800;
  }

  @media screen and (max-width: 568px) {
    div {
      display: none;
    }
  }
</style>
